import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=71a82954&scoped=true"
import script from "./ranking.vue?vue&type=script&lang=js"
export * from "./ranking.vue?vue&type=script&lang=js"
import style0 from "./ranking.css?vue&type=style&index=0&id=71a82954&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a82954",
  null
  
)

export default component.exports